import { useEffect, useRef, useState } from "react"

const useFaqSingle = ({ single, propIndex, open, onClick }) => {
  const [isOpen, setIsOpen] = useState(open)
  const [index, setIndex] = useState(null)
  const initialized = useRef(false)
  const firstRender = useRef(true)

  const itemId = `ds-item-${index}`
  const panelId = `ds-panel-${index}`

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = (index) => {
    if (onClick) onClick(index)
    if (single) {
      toggleAccordion()
    }
  }

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true
      return
    }
    if (open !== null) {
      setIsOpen(open)
    }
  }, [open])

  useEffect(() => {
    setIndex(propIndex ?? 1)
  }, [])

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }
  }, [isOpen])

  return {
    isOpen,
    itemId,
    panelId,
    index,
    handleClick,
  }
}

export default useFaqSingle
